export default "__VITE_ASSET__D0c0VniQ__"